import { AiChatActivityPhase } from 'constants/aiChat';

export const ACTIVITY_BAR_LABELS = {
  [AiChatActivityPhase.IDLE]: 'Waiting for your message',
  [AiChatActivityPhase.AWAITING_APPROVAL]: 'Waiting for your approval',
  [AiChatActivityPhase.WRITING]: 'Writing response\u2026',
  [AiChatActivityPhase.RUNNING_TOOL]: 'Working\u2026',
  [AiChatActivityPhase.PLANNING]: 'Planning\u2026',
  [AiChatActivityPhase.THINKING]: 'Thinking\u2026',
  [AiChatActivityPhase.STILL_THINKING]: 'Still thinking\u2026',
};

export const ACTIVITY_ICON_SIZE = 16;

export const RUNNING_TOOL_LABEL_MAX_LENGTH = 36;

export const RUNNING_TOOL_HOLD_MS = 500;

export const PULSING_PHASES = new Set([
  AiChatActivityPhase.AWAITING_APPROVAL,
  AiChatActivityPhase.WRITING,
  AiChatActivityPhase.RUNNING_TOOL,
  AiChatActivityPhase.PLANNING,
  AiChatActivityPhase.THINKING,
  AiChatActivityPhase.STILL_THINKING,
]);
